import { useQuery } from "react-query";
import {
  getEmployeeStatus,
  getEmployeeStatusFilter,
} from "../../../../../actions/Utilities/EmployeeStatus";

export const useEmployeeStatus = () => {
  const { data } = useQuery("GetEmployeeStatus", getEmployeeStatus, {
    refetchOnWindowFocus: false,
  });
  return data;
};

export const useEmployeeStatusFilter = () => {
  return useQuery("GetEmployeeStatusFilter", getEmployeeStatusFilter, {
    refetchOnWindowFocus: false,
  });
};
